import React from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button, Combobox, Box as Form, Input } from '@node-space/ui-components'
import { RequestError } from 'components/Errors/RequestError'
import { useMerchantForm } from '../hooks/useMerchantForm'

interface MerchantFormProps {
  action: 'EDIT' | 'CREATE'
}

export const MerchantForm = ({ action }: MerchantFormProps) => {
  const { t } = useTranslation()
  const [sheetAction] = useAtom(actionAtom)

  const {
    formFields,
    isLoadingWallets,
    isLoadingAddMerchant,
    isLoadingEditMerchant,
    requestError,
    handleSubmit,
    onSubmit,
    setValue,
    shouldDisable,
    getWalletOptions,
  } = useMerchantForm({ action })

  return (
    <Form tag="form" width="full" flexCol gapY={16} onSubmit={handleSubmit(onSubmit)}>
      <Input
        {...formFields.merchantName}
        testId="merchant-name"
        placeholderText={t('merchantName')}
        required
        onChange={e => {
          setValue('merchantName', e?.target?.value, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }}
      />
      <Combobox {...formFields.walletId} items={getWalletOptions} loading={isLoadingWallets} />
      <Input
        {...formFields.webhookUrl}
        testId="merchant-webhook"
        optionalText={t('optionalFld')}
        placeholderText="https://"
        onChange={e => {
          setValue('webhookUrl', e?.target?.value, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }}
      />
      {requestError?.show && <RequestError>{requestError?.handledMessage}</RequestError>}
      <Box flex justify="between" paddingT={16}>
        <Button testId="back" variant="secondary" onClick={sheetAction?.onClose}>
          {t('cancel')}
        </Button>
        <Button
          testId="merchant-save-btn"
          type="submit"
          variant="primary"
          loading={action === 'CREATE' ? isLoadingAddMerchant : isLoadingEditMerchant}
          disabled={shouldDisable()}
        >
          {action === 'CREATE' ? t('createMerchant') : t('save')}
        </Button>
      </Box>
    </Form>
  )
}
